import { render } from "./aAccountDetails.vue?vue&type=template&id=3c32cf1a&ts=true"
import script from "./aAccountDetails.vue?vue&type=script&lang=ts"
export * from "./aAccountDetails.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__